import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TuiAvatar } from '@taiga-ui/kit';
import { TuiAutoColorPipe, TuiDataList, TuiFallbackSrcPipe, TuiInitialsPipe } from '@taiga-ui/core';
import { SharedModule } from '@src/app/shared';
import { ComponentsModule } from '@src/app/components';
import { IconModule } from '@src/app/modules/icon';

import { UserComponent } from './user.component';

@NgModule({
  declarations: [UserComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    TuiAvatar,
    ComponentsModule,
    ...TuiDataList,
    IconModule,
    FormsModule,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
  ],
  exports: [UserComponent],
})
export class UserModule {}
